import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../../i18n/i18n';
import { toast } from 'react-toastify';
import Select from 'react-select';
import ReactSelect from '../../../utils/ReactSelect';
import { getParcel, deleteParcel, setInitialState, setRowInReducer, getOwnershipDropDown, parcelTable } from '../../../actions/catastral_data/ParcelActions';
/* import AddParcel from './AddParcel'; */
import { getFarmersDropdown } from '../../../actions/financial/IncentiveActions';
import {
    getLocalGov
} from '../../../actions/FarmRegistarActions';
import { getLayerDropDown } from '../../../actions/catastral_data/LayerActions';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import immutable from 'seamless-immutable';
/* import { Delete } from '../../../utils/Delete'; */

import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button, IconButton, Fab,
    Dialog, DialogContent, DialogActions, Card
} from '@material-ui/core';
import axios from '../../../utils/AxiosWrapper';
const CheckboxTable = checkboxHOC(ReactTable);

export class ViewParcel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            showFilters: false,
            selection: [],
            delete: false,
            selectAll: false,
            name: '',
            edit: false
        };
    }

    componentDidMount() {
        if (this.props.localGoverments.length == 0) {
            this.props.getLocalGov();
        }
        if (this.props.ownershipDropDown.length == 0) {
            this.props.getOwnershipDropDown();
        }
        if (this.props.farmerDropdown.length === 0) {
            this.props.getFarmersDropdown();
        }
        if (this.props.layerDropDown.length === 0) {
            this.props.getLayerDropDown();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            parcel: nextProps.parcel,
            parcelFetching: nextProps.parcelFetching,
            farmerDropdown: immutable.asMutable(nextProps.farmerDropdown.map((item) => { return { label: item.kontakt_osoba, value: item.id } }), { deep: true }),
            localGoverments: immutable.asMutable(nextProps.localGoverments.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            ownershipDropDown: immutable.asMutable(nextProps.ownershipDropDown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            layerDropDown: immutable.asMutable(nextProps.layerDropDown.map((item) => { return { label: item.naziv, value: item.id, id_sezona: item.id_sezona } }), { deep: true }),

        })
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getParcel(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
                name: ''
            })
            this.props.setInitialState('parcelObj');
            this.props.setInitialState('deleted');
        }
        if (nextProps.parcelPostingSuccess === true) {
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getParcel(wrapped.state);
            this.props.setInitialState('parcelPostingSuccess');
        }
        if (nextProps.deleteParcelFailed === true) {
            toast.error(i18n.t('This item can not be deleted!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('deleteParcelFailed');
        }

    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
            this.props.setInitialState('parcelObj');
        } else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) {
            this.props.setInitialState('parcelObj');
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    name: '',
                    selectAll: false,
                })
            }
        });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            this.props.setInitialState('parcelObj');
        } else {
            selection.push(key);
        }
        this.setState({ selection, name: 'parcel' }, function () {
            if (selection.length == 1) {
                let row1 = this.props.parcel.filter((parc) => {
                    return parc.id == selection;
                })
                this.props.setRowInReducer(row1[0]);
            }
        });
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection, name: 'parcel' });


    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteParcel(this.state.selection);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }

    // Export all filtered data from backend to Excel
    onExportClick = async () => {
        // Prepare columns (headers) - Serbian translation
        const columns = [
            { label: 'Broj', value: 'broj' },
            { label: 'Opština', value: 'naziv_kat_opstine' },
            { label: 'Potes', value: 'potes' },
            { label: 'Broj nepokretnosti', value: 'br_lista' },
            { label: 'Klasa', value: 'klasa' },
            { label: 'Površina zemljišta', value: 'povrsina' },
            { label: 'Vlasništvo', value: 'vlasnistvo' },
            { label: 'Klijent', value: 'kontakt_osoba' },
            { label: 'Zakup od', value: 'zakup_od' },
            { label: 'Zakup do', value: 'zakup_do' }
        ];

        // Get current filters and sorting from ReactTable
        let filtered = [];
        let sorted = [];
        if (this.checkboxTable && this.checkboxTable.getResolvedState) {
            const state = this.checkboxTable.getResolvedState();
            filtered = state.filtered || [];
            sorted = state.sorted || [];
        }

        let data = [];
        try {
            // Send filters and sorting to backend
            const params = {
                all: true
            };
            if (filtered.length > 0) params.filtered = filtered.map(f => JSON.stringify(f));
            if (sorted.length > 0) params.sorted = JSON.stringify(sorted);
            const response = await axios.get(`/api/parcela/read`, { params });
            // Axios puts the response data in response.data
            data = response.data.data;
            console.log('Received data:', data);
        } catch (error) {
            toast.error('Greška pri preuzimanju svih parcela!', { position: 'top-center' });
            console.error('Export error:', error);
            return;
        }

        if (!data || data.length === 0) {
            toast.warn('Nema podataka za eksport!', { position: 'top-center' });
            console.warn('Export data is empty:', data);
            return;
        }
        // Debug: log the data to be exported
        console.log('Exporting data:', data);
        // Create worksheet data
        const worksheetData = [columns.map(col => col.label)];
        data.forEach(row => {
            worksheetData.push(columns.map(col => row[col.value]));
        });

        // Use SheetJS to export
        import('xlsx').then(XLSX => {
            try {
                const ws = XLSX.utils.aoa_to_sheet(worksheetData);
                ws['!cols'] = Array(columns.length).fill({ width: 15 });
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Parcels');
                XLSX.writeFile(wb, 'parcels_export.xlsx');
                console.log('Excel file should be downloading now.');
            } catch (err) {
                console.error('Error during XLSX export:', err);
                toast.error('Greška pri eksportovanju Excel fajla.', { position: 'top-center' });
            }
        }).catch((err) => {
            console.error('Error loading xlsx:', err);
            toast.error('Neuspešan eksport u Excel. Proverite da li je xlsx instaliran.', { position: 'top-center' });
        });
    }

    onCopyClick = () => {
        this.setState({ layerPopup: true })
    }

    closePopup = () => {
        this.setState({ layerPopup: false })
    }

    handleLayer = () => {
        const { layerSelected, selection } = this.state;
        this.props.parcelTable(selection, layerSelected);
        this.setState({ layerPopup: false, layerSelected: null });
    }

    handleChangeLayer = selectedOption => {
        this.setState({ layerSelected: selectedOption });
    }



    render() {
        const { theme, classes } = this.props;
        const { selectAll, layerDropDown, selection, layerPopup } = this.state;
        const columns = [
            {
                Header: i18n.t('Number'),
                accessor: 'broj'
            }/* ,
            {
                Header: i18n.t('Crop'),
                accessor: 'naziv_kat_kulture',
            } */,
            {
                Header: i18n.t('Local government'),
                accessor: 'naziv_kat_opstine',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.localGoverments}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Potes'),
                accessor: 'potes'
            },
            {
                Header: i18n.t('Immovable property number'),
                accessor: 'br_lista'
            },
            {
                Header: i18n.t('Class'),
                accessor: 'klasa'
            },
            {
                Header: i18n.t('Land area'),
                accessor: 'povrsina'
            },
            /*  {
                 Header: i18n.t('State area'),
                 accessor: 'povrsina_drz'
             }, */
            // {
            //     Header: i18n.t('Farmer'),
            //     accessor: 'klijent_naziv',
            //     Filter: ({ filter, onChange }) =>
            //         <Select
            //             isMulti
            //             name="naziv"
            //             onChange={value => {
            //                 onChange(value)
            //             }}
            //             closeMenuOnSelect={false}
            //             options={this.state.farmerDropdown}
            //             className="multi-select-in-filter"
            //             classNamePrefix="select"
            //             placeholder={i18n.t('Select')}
            //         />
            // },
            {
                Header: i18n.t('Ownership'),
                accessor: 'vlasnistvo',
                width: 200,
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.ownershipDropDown}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Klijent'),
                accessor: 'kontakt_osoba',
                width: 200
            },
            {
                Header: i18n.t('Lease from'),
                accessor: 'zakup_od'
            },
            {
                Header: i18n.t('Lease to'),
                accessor: 'zakup_do'
            },

        ];
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "lightgreen" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        const filterOptions = {
            defaultFiltered:
                [
                    {
                        id: 'klijent_naziv',
                        value: this.props.klijent_naziv ? this.props.klijent_naziv : []
                    }
                ]
        };
        return (
            <div className="page">
                {this.props.isParcelShown ?
                    <div>
                        <DialogTitle disableTypography={true} className="responsive-dialog-title">{i18n.t('Parcels')}
                            <IconButton onClick={this.props.handleCloseParcel}>
                                <span className="icon-cancel-circle closeIcon" />
                            </IconButton>
                        </DialogTitle>
                    </div>
                    : null}
                <div className="table-header">
                    {/* {!this.props.klijent_naziv ?
                        <Fab
                            onClick={() => this.handleClick()}
                            color="primary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Plus headerIcon" />
                        </Fab> : null} */}
                    {!this.props.klijent_naziv ?
                        <Fab
                            onClick={() => this.onSearchClick()}
                            color="secondary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-search headerIcon" />
                        </Fab>
                        : null
                    }
                    <Fab onClick={() => this.onExportClick()}
                        color="secondary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-download headerIcon" />
                    </Fab>
                    {/* {this.state.selection.length === 1 ?
                        <Fab
                            onClick={() => this.onEditClick()}
                            color="primary"
                            aria-label="edit"
                            className="action-button"
                        >
                            <span className="icon-Izmeni1 headerIcon" />
                        </Fab>
                        : null
                    }
                    {this.state.selection.length > 0 ?
                        <Fab
                            onClick={() => this.onDeleteClick()}
                            color="primary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Kanta headerIcon" />
                        </Fab>
                        : null
                    }
                    {this.state.selection.length > 0 ?
                        <Fab
                            onClick={() => this.onCopyClick()}
                            color="primary"
                            aria-label="add"
                            className="action-button"
                        >
                            <span className="icon-Fields headerIcon" />
                        </Fab>
                        : null
                    } */}
                </div>
                <ReactTable data={this.props.parcel}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.parcelPages}
                    loading={this.props.parcelFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getParcel(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    {...filterOptions}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {/*  {this.state.add && <AddParcel add={this.state.add} edit={this.state.edit}
                    handleClose={this.handleClick} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />} */}
                {layerPopup &&
                    <Dialog
                        open={layerPopup}
                        onClose={this.closePopup}
                        disableBackdropClick
                        maxWidth="xm"
                        aria-labelledby="responsive-dialog-title"
                    >
                        <DialogTitle id="responsive-dialog-title">{i18n.t('Layer')}</DialogTitle>
                        <DialogContent style={{ minHeight: '200px' }}>
                            <ReactSelect
                                // closeMenuOnSelect={true}
                                isClearable={true}
                                maxMenuHeight={100}
                                isMulti={false}
                                menuPlacement="auto"
                                defaultMenuIsOpen
                                // value={layerDropDown.filter((element) => {
                                //     return layerDropDown && layerDropDown.some((item) => item.id === layerDropDown.value)
                                // })}
                                onChange={this.handleChangeLayer}
                                options={layerDropDown}
                                className="react-select-dropdown-layer"
                                classNamePrefix="select"
                                placeholder={i18n.t('Select')}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={this.handleLayer}
                                variant="contained"
                                color="primary">
                                {i18n.t('Ok')}
                            </Button>
                            <Button
                                onClick={this.closePopup}
                                variant="contained"
                                color="primary">
                                {i18n.t('Cancel')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </div>

        )
    }


};

function mapStateToProps(state) {
    return {
        parcel: state.parcelReducer.parcel,
        parcelFetching: state.parcelReducer.parcelFetching,
        parcelPages: state.parcelReducer.parcelPages,
        deleted: state.parcelReducer.deleted,
        deleteParcelFailed: state.parcelReducer.deleteParcelFailed,
        parcelPostingSuccess: state.parcelReducer.parcelPostingSuccess,
        parcelObj: state.parcelReducer.parcelObj,
        localGoverments: state.farmRegistarReducer.localGoverments,
        ownershipDropDown: state.parcelReducer.ownershipDropDown,
        farmerDropdown: state.incentiveReducer.farmerDropdown,
        layerDropDown: state.layerReducer.layerDropDown,
        layerFetchingDropDown: state.layerReducer.layerFetchingDropDown,
        layerFetchingFailedDropDown: state.layerReducer.layerFetchingFailedDropDown,
        addParcelTableSuccess: state.parcelReducer.addParcelTableSuccess,

    }
}

function mapDispatchToProps(dispatch) {
    return {
        getParcel: (state, instance) => dispatch(getParcel(state, instance)),
        deleteParcel: (selection, name) => dispatch(deleteParcel(selection, name)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo) => dispatch(setRowInReducer(rowInfo)),
        getLocalGov: () => dispatch(getLocalGov()),
        getOwnershipDropDown: () => dispatch(getOwnershipDropDown()),
        getFarmersDropdown: () => dispatch(getFarmersDropdown()),
        getLayerDropDown: () => dispatch(getLayerDropDown()),
        parcelTable: (id_parcela, selected) => dispatch(parcelTable(id_parcela, selected))


    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewParcel)